import clsx from 'clsx'
import {ColumnInstance, Row, UseSortByColumnProps} from 'react-table'
import {Transaction, LedgerData} from '../API/ViewTransactionsAPI'
import {formatNumber} from '../../../../_metronic/helpers'

type ColProps = {
  column: ColumnInstance<Transaction> & UseSortByColumnProps<Transaction>
}

export const CustomHeaderColumn: React.FC<ColProps> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps(column.getSortByToggleProps())} className='cursor-pointer'>
        {column.render('Header')}
        <span className='ms-1'>{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
      </th>
    ) : (
      column.render('Header')
    )}
  </>
)

type RowProps = {
  row: Row<Transaction>
  ledgers: Record<string, LedgerData>
}

export const CustomRow: React.FC<RowProps> = ({row, ledgers}) => {
  const transaction = row.original

  // // console.log(row)
  return (
    <>
      <tr {...row.getRowProps()} className='bg-hover-light'>
        {row.cells.map((cell, i) => {
          return (
            <td
              {...cell.getCellProps()}
              className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
            >
              {cell.render('Cell')}
            </td>
          )
        })}
      </tr>
      {transaction.transactionItems.map((tr, i) => {
        const ledgerInfo = ledgers[tr.ledgerId]
        return (
          <tr
            key={i}
            style={
              i + 1 === transaction.transactionItems.length
                ? {
                    borderColor: 'var(--bs-text-gray-300) !important',
                  }
                : {}
            }
            className={
              i + 1 === transaction.transactionItems.length
                ? 'border-bottom bg-hover-light'
                : 'bg-hover-light'
            }
          >
            <td colSpan={4}></td>
            <td className='p-0 '>
              <em className='d-flex text-center align-content-center justify-content-center'>
                <span className='text-dark fw-bolder'>{ledgerInfo?.parentLedger}&nbsp;&nbsp;</span>
                <span className='text-dark fw-semibold'>
                  {ledgerInfo?.subLedger && ` - ${ledgerInfo?.subLedger} `}
                </span>
                <span className={tr.transactionType === 'credit' ? 'text-success' : 'text-danger'}>
                  {transaction.currencyCode} {formatNumber(tr.transactionAmount)}
                  {tr.transactionType === 'credit' ? ' CR' : ' DR'}
                  {transaction.reportingCurrency !== transaction.currencyCode &&
                    `  (${transaction.currencyCode} ${formatNumber(
                      transaction.totalAmount / transaction.exchangeMultiplier
                    )})`}
                </span>
              </em>
            </td>
            <td></td>
            <td></td>
          </tr>
        )
      })}
    </>
  )
}

export const styles = {
  borderRadius: '0.475rem',
  boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
  backgroundColor: '#fff',
  color: '#7e8299',
  fontWeight: '500',
  margin: '0',
  width: 'auto',
  padding: '1rem 2rem',
  top: 'calc(50% - 2rem)',
  left: 'calc(50% - 4rem)',
}
